import { render } from "./invalid.vue?vue&type=template&id=9fb51010&scoped=true"
const script = {}

import "./invalid.vue?vue&type=style&index=0&id=9fb51010&scoped=scoped&lang=css"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb51010"]])

export default __exports__